<template>
  <div class="filter-kpi" :class="{ 'filter-kpi--active': isActive }">
    <div class="filter-kpi__label">
      {{ label }}
    </div>
    <div class="filter-kpi__icon backoffice-icons" v-if="buttonIsActive">
      chevron_down
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterKpi',
  props: {
    label: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    buttonIsActive: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-kpi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all $transition-duration-medium $transition-effect-default;
  border-bottom: 1px solid $generic-color-bg;
  background-color: $grey-athens-light;
  cursor: pointer;
  padding: 10px $spacing-sm;
  text-transform: uppercase;

  &:hover,
  &:focus {
    background: map-get($generic-color-variants, 'gtr');
    cursor: pointer;
    color: $generic-color-text-alt;
  }

  &--active {
    border-left: map-get($generic-color-variants, 'gtr') 5px solid;
    color: map-get($generic-color-variants, 'gtr');
  }

  &__label {
    flex: 1;
    font-weight: 500;
  }

  &__icon {
    transition: transform $transition-duration-default $transition-effect-default;
    margin-left: 12px;
    border-radius: 50%;
    background-color: $generic-color-bg;
    width: 24px;

    .filter-kpi--active & {
      transform: rotate(180deg);
      background-color: $generic-color-bg;
      color: map-get($generic-color-variants, 'gtr');
    }
  }
}
</style>
